<template>
  <el-dialog :title="modalInfo.title" :visible.sync="modalInfo.isShow" v-if="modalInfo.isShow" width="30%">
    <el-form :model="modalInfo.form" :rules="rules" ref="ruleForm">
      <el-form-item label="名称" prop="dictName" :label-width="formLabelWidth" >
        <el-input v-model.trim="modalInfo.form.dictName"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="Code" prop="dictCode" :label-width="formLabelWidth">
        <el-input v-model.trim="modalInfo.form.dictCode" size="small"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sortNumber" :label-width="formLabelWidth">
        <el-input v-model.trim="modalInfo.form.sortNumber" ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" class="confirm" @click="confirmClick()">确 定</el-button>
      <el-button size="small" class="cancel" @click="modalInfo.isShow = false">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {fetchGet, fetchPost} from "@/libs/reqCommon";
export default {
    name:'newAddModel',
    props:{
      modalInfo:{
          type:Object,
          default:() =>{}
      }
    },
    data(){
      return {
          formLabelWidth:"120px",
          rules: {
            dictName: [
              { required: true, message: '名称不能为空', trigger: 'blur' }
            ],
            dictCode: [
              { required: true, message: 'Code不能为空', trigger: 'blur' }
            ]
          }
      }
    },
    methods:{
      confirmClick(){
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.reqNewAdd();
          } else {
            return false;
          }
        });
      },
      // 新增/编辑请求
      reqNewAdd(){
        let url = "/hcm/sys/Create";
        if(this.modalInfo.parentId) this.modalInfo.form.parentId = this.modalInfo.parentId;
        if(this.modalInfo.title == "编辑"){
          url = "/hcm/sys/Update";
          this.modalInfo.form = {
            dictName:this.modalInfo.form.dictName,
            dictCode: this.modalInfo.form.dictCode,
            id: this.modalInfo.form.id,
            parentId: this.modalInfo.form.parentId,
            sortNumber: this.modalInfo.form.sortNumber
          }
        }
        fetchPost(url,this.modalInfo.form).then(res =>{
          if(res.status == '10000'){
            this.$message({
              message: '操作成功！',
              type: res.message
            })
            this.modalInfo.isShow = false;
            this.$emit("reqTableData")
          }else{
            this.$message.error(res.message?res.message:'操作失败！');
          }     
        })
      }
    }
}
</script>
<style lang="scss">

</style>


